import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider, theme } from "antd";
import rootReducer from "./stores/reducers";
import { configureStore } from "@reduxjs/toolkit";
import App from "./App.tsx";
import "./i18n";
import "./style/reset.less";
import "./style/base/modal.less";
import "./style/base/radio.less";
import "./style/base/popover.less";
import "./style/base/select.less";
import "./index.less";
import { Web3Provider } from "./provider/Web3Provider.tsx";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { Buffer } from "buffer";
import AppProviders from './provider/AppProviders';

import {
  primaryColor,
  primaryColorHover,
  inputActiveShadowColor,
  radioButtonBgColor,
  primaryFontColor,
} from "./config/color.ts";
import { CDN_BASE } from "./config/index.tsx";

window.Buffer = Buffer; // 确保 Buffer 可用

const store = configureStore({
  reducer: rootReducer,
});

// const cdnBase = CDN_BASE || '';
// document.documentElement.setAttribute('data-cdn-base', cdnBase);

createRoot(document.getElementById("root")!).render(
  <StrictMode>

    <BrowserRouter>
      <HelmetProvider>
        <Provider store={store}>
          <ConfigProvider
            theme={{
              // 1. 单独使用暗色算法
              // algorithm: theme.darkAlgorithm,
              token: {
                fontFamily: "PingFang SC, PingFang SC",
                colorPrimary: primaryColor,
                // colorTextQuaternary: '#3A4663',
                // colorBgContainerDisabled: '#CCCCCC',
                colorBorder: "#0000004D",
                // colorBgContainer: "#CCCCCC"
              },
              components: {
                Switch: {
                  /* 这里是你的组件 token */
                  handleBg: "#FFFFFF",
                  handleSize: 16,
                  trackMinWidth: 40,
                  trackHeight: 20,
                  colorPrimary: primaryColor,
                  colorPrimaryHover: primaryColorHover,
                },
                Progress: {
                  lineBorderRadius: 0,
                },
                Layout: {
                  siderBg: "#262B3F",
                },
                Menu: {
                  itemMarginBlock: 5,
                  itemMarginInline: 0,
                  itemHeight: 62,
                  itemBg: "rgba(255, 255, 255, .1)",
                  itemSelectedBg: "rgba(255, 255, 255, .1)",
                  itemActiveBg: "rgba(255, 255, 255, .1)",
                  itemHoverBg: "rgba(255, 255, 255, .1)",
                  itemHoverColor: "rgba(255, 255, 255, .8)",
                  itemColor: "rgba(255, 255, 255, .8)",
                  itemSelectedColor: "rgba(255, 255, 255, .8)",
                  itemBorderRadius: 10,
                  itemPaddingInline: 9,
                  iconMarginInlineEnd: 20,
                  iconSize: 20,
                },
                InputNumber: {
                  activeBorderColor: inputActiveShadowColor,
                  hoverBorderColor: inputActiveShadowColor,
                  colorBgContainerDisabled: "#fff",
                  borderRadius: 8,
                  activeShadow: "none",
                },
                Input: {
                  // colorBorder: "#0000004D",
                  activeBorderColor: inputActiveShadowColor,
                  hoverBorderColor: inputActiveShadowColor,
                  activeShadow: "none",
                },
                Radio: {
                  buttonColor: "#000000",
                  buttonBg: radioButtonBgColor,
                  buttonCheckedBg: primaryColor,
                },
                Select: {
                  // colorBorder: "#0000004D",
                  activeBorderColor: inputActiveShadowColor,
                  activeOutlineColor: "none",
                  hoverBorderColor: inputActiveShadowColor,
                  // activeOutlineColor: "var(--primary-color-hover)",
                  fontSize: 12,
                  controlHeight: 24,
                  optionSelectedBg: "rgba(0, 0, 0, 0.04)",
                },
                Checkbox: {
                  colorPrimary: primaryColor,
                  colorPrimaryHover: primaryColorHover,
                },
                Form: {
                  fontSize: 12,
                },
                Button: {
                  colorPrimary: primaryColor,
                  defaultHoverBg: primaryColorHover,
                },
                Tooltip: {
                  fontSize: 12,
                  colorBgSpotlight: "#525252",
                  borderRadius: 8,
                },
                Dropdown: {
                  fontSize: 12,
                },
              },

              // 2. 组合使用暗色算法与紧凑算法
              // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
            }}
          >
            <Web3Provider>
              <AppProviders>
                <App />
              </AppProviders>
            </Web3Provider>
          </ConfigProvider>
        </Provider>
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode >
);
